import axios from "axios";

export interface UserInfoResponse {
    dealerCode: string;
    firstName: string;
    lastName: string;
    loginUrl: string;
    roles: string[];
    username: string;
    internalUser: boolean;
    canAccessContentManagement: boolean;
    canManageUsers: boolean;
    canManageAdminUsers: boolean;
    canProvideAfterSalesCare: boolean;
    canSearchApplications: boolean;
    canStartNewApplications: boolean;
    kerberos: boolean;
    associatedDealers: string[];
    userInfoRetrieved: boolean;
}

export async function fetchUserInfo(endpoint: string): Promise<UserInfoResponse> {
    const response = await axios({
        timeout: 600000,
        method: "get",
        url: endpoint
    });
    return response.data;
}
